import { ChevronDown, Info } from "lucide-react";
import { useTranslation } from "react-i18next";
import { formatConversationTime } from "src/components/GlobalChatbot/groupConversationsByDate";
import type { ChatbotConversationDetails as ConversationDetails } from "src/components/GlobalChatbot/types";

interface ChatbotConversationDetailsProps {
	details: ConversationDetails;
}

export const ChatbotConversationDetails = ({
	details,
}: ChatbotConversationDetailsProps) => {
	const { t } = useTranslation();

	return (
		// ponytail: natywny <details> — stan otwarcia trzyma przeglądarka
		<details className="chatbot-details">
			<summary
				className="chatbot-details-summary"
				data-test-id="global-chatbot-details-toggle"
			>
				<Info className="icon-small" />
				<span>
					{t("globalChatbot.details.title", "Detale rozmowy")}
					{" · "}
					{t("globalChatbot.details.promptsCount", "{{count}} zapytań", {
						count: details.promptsCount,
					})}
					{" · "}
					{t("globalChatbot.details.questionsCount", "{{count}} pytań", {
						count: details.questions.length,
					})}
				</span>
				<ChevronDown className="icon-small chatbot-details-chevron ml-auto" />
			</summary>

			<div className="chatbot-details-body scroll">
				<div className="chatbot-history-group-label">
					{t(
						"globalChatbot.details.contextQuestions",
						"Pytania użyte jako kontekst",
					)}
				</div>
				<div className="flex flex-col gap-8">
					{details.questions.map((question) => (
						<div
							key={question.id}
							data-test-id="global-chatbot-details-question"
							className="chatbot-history-item chatbot-history-item--static"
						>
							<span className="chatbot-history-item-question">
								{question.preview}
							</span>
							<span className="chatbot-history-item-meta">
								<span className="size-12-light text-grey">
									{t(
										"globalChatbot.details.promptsCount",
										"{{count}} zapytań",
										{
											count: question.promptsCount,
										},
									)}
								</span>
								{question.askedAt && (
									<span className="size-12-light text-grey ml-auto">
										{formatConversationTime(question.askedAt)}
									</span>
								)}
							</span>
						</div>
					))}
				</div>
			</div>
		</details>
	);
};
